import store from '@/state/store';
import { setParticipantBlocked } from '@/api/project';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import { runBulk } from '../utils';

export default async (code: string, participants: string[], blocked: boolean) => {
  try {
    const ids = await runBulk(
      participants,
      (uid) => setParticipantBlocked(code, uid, blocked).then(() => uid),
      (e) => handleError(e)
    );

    store.dispatch(
      projectSlice.actions.setParticipantsBlocked({
        code,
        ids,
        blocked,
      })
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};